import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import SignInSide from "./pages/signIn/SignInSide";
import ForgotPasswordView from "./pages/forgotPassword/ForgotPasswordView";
import ResetPasswordView from "./pages/resetPassword/ResetPasswordView";
import { PrivateRoutes } from "./authentication/PrivateRoutes";
import Home from "./pages/home";
import TimelineView from "./pages/timelineView";

function Router() {
  const token = localStorage.getItem("access");

  const routes = [
    {
      path: "/",
      element: token ? <PrivateRoutes component={Home} /> : <SignInSide />,
    },
    {
      path: "/login",
      element: token ? <PrivateRoutes component={Home} /> : <SignInSide />,
    },
    {
      path: "/forgot-password",
      element: <ForgotPasswordView />,
    },
    {
      path: "/reset-password",
      element: <ResetPasswordView />,
    },
    {
      path: "/audit-list",
      element: <PrivateRoutes component={Home} />,
    },
    {
      path: "/timeline-view?",
      element: <PrivateRoutes component={TimelineView} />,
    }
  ];

  const router = createBrowserRouter(routes);

  return <RouterProvider router={router} />;

}

export default Router;
